import _sfc_main from "./Header.vue2.js";
import "./Header.vue3.js";
import _export_sfc from "../_virtual/_plugin-vue_export-helper.js";
const Header = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-11a7b89c"]]);
export {
  Header as default
};
